import { render, staticRenderFns } from "./AdminFormsPopup.vue?vue&type=template&id=04dce4f8&scoped=true&"
import script from "./AdminFormsPopup.vue?vue&type=script&lang=js&"
export * from "./AdminFormsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dce4f8",
  null
  
)

export default component.exports